import { Injectable } from '@angular/core';

import { CmsService, Occ } from '@spartacus/core';

import { DpNewsPageMetaResolver } from './news-page-meta.resolver';

import PageType = Occ.PageType;

@Injectable({
  providedIn: 'root',
})
export class DpNewsOverviewPageMetaResolver extends DpNewsPageMetaResolver {
  constructor(protected cms: CmsService) {
    super(cms);
    this.pageType = <PageType>'OverviewPage';
    this.pageTemplate = 'OverviewPageTemplate';
  }
}
